<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Budget Tracker") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <multiselect
                  :options="yearArr"
                  v-model="selectedYear"
                  :searchable="false"
                  label="year"
                  track-by="year_id"
                  placeholder="Select Year"
                  @input="onSelectYear($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
                <label :class="selectedYear.year_id != null ? 'active' : ''">
                  Select Year
                </label>
              </div>
            </div>
          </div>

          <!-- <div
          class="d-flex justify-content-end mt-5 align-items-center"
          v-if="getFnBComboReport.length"
        >
          <div>{{ $t("download") }} as:</div>
          <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a href="#" @click="excelDownload()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div> -->
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table" v-if="payload.budget_month_wise">
          <thead class="bg-lightgrey">
            <th>Month</th>
            <th>Admit Budget</th>
            <th>ATP Budget</th>
            <th>SPH Budget</th>
          </thead>
          <tbody>
            <tr
              v-for="(monthData, monthIndex) in payload.budget_month_wise"
              :key="monthIndex + 'monthsIndexing'"
            >
              <td class="text-left">
                {{ monthData.month }}
              </td>
              <td>
                <div class="input-material">
                  <input type="text" v-model="monthData.admit_budget" />
                </div>
              </td>
              <td>
                <div class="input-material">
                  <input type="text" v-model="monthData.atp_budget" />
                </div>
              </td>
              <td>
                <div class="input-material">
                  <input type="text" v-model="monthData.sph_budget" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="w-100">
        <div class="col-lg-6 col-xl-3 my-3 ml-auto">
          <button
            class="btn-blue-lg w-100"
            @click="onSaveData"
            v-if="payload.budget_month_wise.length > 0"
          >
            Save
          </button>
        </div>
      </div>
      <!---New-->
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import BudgetService from "@/services/BudgetService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      selectedYear: {
        year_id: 123,
        year: moment().format("YYYY")
      },
      yearArr: [],
      monthsArr: [],
      payload: {
        cinema_id: "",
        year: moment().format("YYYY"),
        ms_budget_id: null,
        budget_month_wise: []
      }
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
    this.setYearArr();
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    }
  },
  mounted() {},
  methods: {
    moment,
    onSelectYear(event) {
      console.log(event);
      this.payload.year = event.year;
      this.getMonthArr();
    },
    onSaveData() {
      let loader = this.$loading.show();

      BudgetService.addEditBudget(this.payload)
        .then(response => {
          const { data } = response;
          loader.hide();
          if (data.status) {
            this.getMonthArr();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getMonthArr() {
      console.log(this.payload, "year");
      if (!this.payload.cinema_id || !this.payload.year) {
        this.payload.budget_month_wise = [];
        return;
      }
      let payloadNew = {
        cinema_id: this.payload.cinema_id,
        year: this.payload.year
      };

      let loader = this.$loading.show();

      BudgetService.GetBudgetListByCinema(payloadNew)
        .then(response => {
          const { data } = response;
          loader.hide();
          if (data.status && data.Records.length > 0) {
            this.payload.ms_budget_id = data.Records[0].ms_budget_id;
            this.payload.budget_month_wise = JSON.parse(
              data.Records[0].budget_month_wise
            );
          } else {
            this.setMonthArr();
          }
        })
        .catch(this._CatchError);
    },
    setYearArr() {
      let currentYear = new Date().getFullYear() - 20;
      for (let i = 1; i <= 20; i++) {
        this.yearArr.push({
          year_id: i,
          year: currentYear + i
        });
      }
      this.yearArr.reverse();
    },
    setMonthArr() {
      this.payload.ms_budget_id = null;
      this.payload.budget_month_wise = [];
      for (let i = 0; i <= 11; i++) {
        this.payload.budget_month_wise.push({
          month_id: moment()
            .startOf("year")
            .add(i, "months")
            .format("MM"),
          month: moment()
            .startOf("year")
            .add(i, "months")
            .format("MMM"),
          atp_budget: "",
          admit_budget: "",
          sph_budget: ""
        });
      }
    },
    getCinemaList: function() {
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
      this.payload.cinema_id = event.cine_id;
      this.getMonthArr();
    }
  }
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/budgetTracker.vue